import { DownOutlined, UploadOutlined } from "@ant-design/icons"
import { Button, Dropdown, Upload } from "antd"
import React, { useRef } from "react"
import { useTranslation } from "react-i18next"

interface FilesUploadMenuProps {
  onUploadFiles: (files: File[]) => void
  onUploadDocument: () => void
  type?: "primary" | "default"
  label?: string
}

export function FilesUploadMenu({
  onUploadFiles,
  onUploadDocument,
  type = "primary",
  label
}: FilesUploadMenuProps) {
  const { t } = useTranslation()
  const pickerRef = useRef<HTMLSpanElement>(null)

  const openFilePicker = () => {
    pickerRef.current?.querySelector<HTMLElement>("input[type=file]")?.click()
  }

  return (
    <>
      <span ref={pickerRef} hidden>
        <Upload
          multiple
          showUploadList={false}
          beforeUpload={(file, fileList) => {
            // antd calls this once per selected file, all sharing the same
            // `fileList` reference — batch the whole selection on the first
            // call so the queue gets one `enqueue`, not N.
            if (file === fileList[0]) onUploadFiles(fileList as File[])
            return false
          }}
        />
      </span>
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            {
              key: "files",
              label: t("files.uploadMenu.files"),
              onClick: openFilePicker
            },
            {
              key: "document",
              label: t("files.uploadMenu.document"),
              onClick: onUploadDocument
            }
          ]
        }}
      >
        <Button type={type} icon={<UploadOutlined />}>
          {label ?? t("files.actionUpload")} <DownOutlined />
        </Button>
      </Dropdown>
    </>
  )
}
